import styled from 'styled-components'

export default styled.div`
  font-size: 16px;
  font-family: 'ABChanel PB Regular S', Arial, sans-serif;
  text-align: center;
  margin: auto;
  width: 80%;
  margin-top: 25%;

  h3 {
    margin-bottom: 22px;
    font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
    font-size: 30px;
  }

  .bottom-msg {
    margin-top: 44px;

    img {
      margin-top: 37px;
      width: 53px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/styles/ThankYou.js